export default __webpack_public_path__ + "static/media/Familyshoot.25de80f5.jpg";